export default __webpack_public_path__ + "static/media/user.c45f9c04.svg";